module.exports = __webpack_public_path__ + "static/img/4.dfe5417.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/1/4.png
// module id = mLN1
// module chunks = 0